<lib-layout>
  <router-outlet></router-outlet>
</lib-layout>
